export default __webpack_public_path__ + "static/media/svnet.5ddee046.png";